webpackJsonp([231608221292675],{

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__(461),
	  options: { "plugins": [] }
	}, {
	  plugin: __webpack_require__(255),
	  options: { "plugins": [] }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   require('/path/to/plugin1/gatsby-browser.js'),
	//   require('/path/to/plugin2/gatsby-browser.js'),
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== 'undefined';
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _exports$json;
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-templates-project-index-js": __webpack_require__(388),
	  "component---src-pages-404-js": __webpack_require__(381),
	  "component---src-pages-fonts-js": __webpack_require__(382),
	  "component---src-pages-index-js": __webpack_require__(383),
	  "component---src-pages-nieuws-js": __webpack_require__(384),
	  "component---src-pages-over-js": __webpack_require__(385),
	  "component---src-pages-projecten-js": __webpack_require__(386),
	  "component---src-pages-zoek-js": __webpack_require__(387)
	};
	
	exports.json = (_exports$json = {
	  "layout-index.json": __webpack_require__(4),
	  "projecten-cabin-training-centre-qatar.json": __webpack_require__(406)
	}, _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-cardboard-office.json"] = __webpack_require__(407), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-de-muts.json"] = __webpack_require__(408), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-ravelijn-bridge.json"] = __webpack_require__(438), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-moses-bridge.json"] = __webpack_require__(431), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-schoolgarden.json"] = __webpack_require__(441), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-spaghetti-bridge.json"] = __webpack_require__(443), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-kiosk-at-ravelijn.json"] = __webpack_require__(424), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-bunkertreppe.json"] = __webpack_require__(405), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-energielinie.json"] = __webpack_require__(411), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-blauwe-sluis.json"] = __webpack_require__(401), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-kansenkaart-steenbergen.json"] = __webpack_require__(422), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-sober.json"] = __webpack_require__(442), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-flying-for-biodiversity.json"] = __webpack_require__(415), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-lettenhofpark.json"] = __webpack_require__(428), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-limes.json"] = __webpack_require__(429), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-evolitiegebouw-nioo-knaw.json"] = __webpack_require__(413), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-zeeuws-ruimtelijk-decreet.json"] = __webpack_require__(458), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-reghthuys-van-wulven.json"] = __webpack_require__(439), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-bamboe-doodskist.json"] = __webpack_require__(397), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-good-house.json"] = __webpack_require__(417), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-brabantse-wal.json"] = __webpack_require__(403), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-koffiehokjes.json"] = __webpack_require__(425), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-stortemelk-beeldkwaliteitsplan.json"] = __webpack_require__(445), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-praxis.json"] = __webpack_require__(437), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-visie-vesting-den-bosch.json"] = __webpack_require__(454), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-evolvo-et-emergo.json"] = __webpack_require__(414), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-biobased-brug.json"] = __webpack_require__(400), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-kansenkaart-groot-saefthinge.json"] = __webpack_require__(421), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-hutje-op-de-hei.json"] = __webpack_require__(420), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-huis-in-de-bosjes.json"] = __webpack_require__(419), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-waterpicknicktafels.json"] = __webpack_require__(456), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-olifantenbrug.json"] = __webpack_require__(433), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-kinderboerderij.json"] = __webpack_require__(423), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-pompejus.json"] = __webpack_require__(436), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-kopie.json"] = __webpack_require__(426), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-sportboulevard.json"] = __webpack_require__(444), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-mcjp.json"] = __webpack_require__(430), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-fort-henricus.json"] = __webpack_require__(416), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-roode-weel.json"] = __webpack_require__(440), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-vogeleiland.json"] = __webpack_require__(455), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-uitkerkse-polder.json"] = __webpack_require__(449), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-blauwehandstraat.json"] = __webpack_require__(402), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-strandfietsen.json"] = __webpack_require__(446), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-bezoekers-informatie-centrum.json"] = __webpack_require__(399), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-t-ij.json"] = __webpack_require__(448), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-entree-peperbus.json"] = __webpack_require__(412), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-waterschans.json"] = __webpack_require__(457), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-de-zeemol.json"] = __webpack_require__(409), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-bergse-heide.json"] = __webpack_require__(398), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-zwaluwenbunders.json"] = __webpack_require__(459), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-oud-reimerswaal.json"] = __webpack_require__(435), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-strandpost-dishoek.json"] = __webpack_require__(447), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-natuurkracht.json"] = __webpack_require__(432), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-veldstation-saeftinghe.json"] = __webpack_require__(452), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-1-april-monument-brielle.json"] = __webpack_require__(396), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-uitkijk-radartoren-hedwigepolder.json"] = __webpack_require__(450), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-ontdekkingsreis-naar-nieuw-zeeland.json"] = __webpack_require__(434), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-uitkijktoren-tureluur.json"] = __webpack_require__(451), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-hub-tholen.json"] = __webpack_require__(418), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-versterk-de-scheldekust.json"] = __webpack_require__(453), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-bridges-lilleakerbyen.json"] = __webpack_require__(404), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-energiehuis-deltawind.json"] = __webpack_require__(410), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten-landgoed-ottermeer.json"] = __webpack_require__(427), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["404.json"] = __webpack_require__(389), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["fonts.json"] = __webpack_require__(391), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["index.json"] = __webpack_require__(392), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["nieuws.json"] = __webpack_require__(393), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["over.json"] = __webpack_require__(394), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["projecten.json"] = __webpack_require__(395), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["zoek.json"] = __webpack_require__(460), _exports$json["layout-index.json"] = __webpack_require__(4), _exports$json["404-html.json"] = __webpack_require__(390), _exports$json);
	
	exports.layouts = {
	  "layout---index": __webpack_require__(380)
	};

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(172);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(69);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _apiRunnerBrowser = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    var location = props.location;
	
	    // Set the pathname for 404 pages.
	    if (!_loader2.default.getPage(location.pathname)) {
	      location = _extends({}, location, {
	        pathname: "/404.html"
	      });
	    }
	
	    _this.state = {
	      location: location,
	      pageResources: _loader2.default.getResourcesForPathname(location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // During development, always pass a component's JSON through so graphql
	    // updates go through.
	    if (false) {
	      if (nextProps && nextProps.pageResources && nextProps.pageResources.json) {
	        this.setState({ pageResources: nextProps.pageResources });
	      }
	    }
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        var location = nextProps.location;
	
	        // Set the pathname for 404 pages.
	        if (!_loader2.default.getPage(location.pathname)) {
	          location = _extends({}, location, {
	            pathname: "/404.html"
	          });
	        }
	
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(location.pathname, function (pageResources) {
	          _this2.setState({
	            location: location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (_loader2.default.getPage(_this3.state.location.pathname) && e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return false;
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceComponentRenderer", {
	      props: _extends({}, this.props, { pageResources: this.state.pageResources }),
	      loader: _loader.publicLoader
	    });
	    var replacementComponent = pluginResponses[0];
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return replacementComponent || (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return replacementComponent || (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(134);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(32);
	
	var pageCache = {}; // TODO add tests especially for handling prefixed links.
	
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = pathname.slice(pathPrefix.length);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createBrowserHistory = __webpack_require__(130);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _apiRunnerBrowser = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceHistory");
	var replacementHistory = pluginResponses[0];
	var history = replacementHistory || (0, _createBrowserHistory2.default)();
	module.exports = history;

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(477) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(478) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(248795187064286, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(479) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(480) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(132) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(98868842627013, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(481) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(38400759304928, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(482) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(247890083760356, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(483) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(18880563214517, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(484) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(147764192795180, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(485) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(24257900884471, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(486) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(141046334233481, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(487) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(217218392598082, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(488) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(203175222738428, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(489) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(191670273747810, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(490) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(108379610096443, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(491) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(159915371040021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(492) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(18754882591266, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(493) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(276562121297940, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(494) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(160301348120113, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(495) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(77023674343147, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(496) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(83349714436077, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(497) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(132215586750227, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(498) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(171456998590975, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(499) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(221103187151122, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(500) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(244369078236718, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(501) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114460070319037, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(502) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(202357126946524, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(503) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(250971600997818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(504) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(97778368460482, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(505) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(89437352718201, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(506) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(197779704064801, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(507) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(36987871396684, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(508) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(183862383322526, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(509) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(88557859531304, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(510) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(14215095819299, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(511) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(205060724914875, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(512) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(274453025651162, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(513) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(228695385151223, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(514) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(187018574729426, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(515) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(158562011765253, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(516) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(175514022873000, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(517) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(186984166393965, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(518) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(197317174828858, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(519) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178726990733169, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(520) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(27318044636042, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(521) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(24624425478647, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(522) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(226803630934834, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(523) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(120499659941916, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(524) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(273657203521417, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(525) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(232954969969100, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(526) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(219646424250525, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(527) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(206834721045438, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(528) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114638061468468, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(529) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(26693331854262, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(530) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(263314505398601, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(531) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(68777593594822, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(532) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(97479762779110, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(533) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(239219765741884, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(534) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(169930942053278, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(535) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(85338829177772, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(536) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(158119790626244, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(537) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(116031217725709, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(538) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(139619211991390, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(539) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(222796515690384, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(540) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(28031539090174, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(541) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(221059540707057, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(542) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(214872037262603, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(543) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178178592942127, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(544) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(187902974367485, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(545) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(55588822138867, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(546) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(15825815884797, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(547) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(139936450982642, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(548) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(252) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	exports.publicLoader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(250);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(69);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(253)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = void 0;
	    if (resourceName.slice(0, 12) === "component---") {
	      resourceFunction = asyncRequires.components[resourceName];
	    } else if (resourceName.slice(0, 9) === "layout---") {
	      resourceFunction = asyncRequires.layouts[resourceName];
	    } else {
	      resourceFunction = asyncRequires.json[resourceName];
	    }
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var module = preferDefault(executeChunk());
	        resourceCache[resourceName] = module;
	        cb(err, module);
	      }
	    });
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    var pathPrefix = "";
	    if (true) {
	      pathPrefix = ("");
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue(path) {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(path) {
	    // Check page exists.
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          // We would probably need this to
	          // prevent unnecessary reloading of the page
	          // while unregistering of ServiceWorker is not happening
	          if (registrations.length) {
	            for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	              var _ref;
	
	              if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	              } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	              }
	
	              var registration = _ref;
	
	              registration.unregister();
	            }
	            window.location.reload();
	          }
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layout],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      var _page = findPage(path);
	
	      if (!_page) {
	        console.log("A page wasn't found for \"" + path + "\"");
	        return cb();
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout, page: _page };
	          var _pageResources = { component: component, json: json, layout: layout, page: _page };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          console.log("Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          console.log("Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layout, function (err, l) {
	        if (err) {
	          console.log("Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	var publicLoader = exports.publicLoader = {
	  getResourcesForPathname: queue.getResourcesForPathname
	};
	
	exports.default = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-cabin-training-centre-qatar.json","path":"/projecten/cabin-training-centre-qatar"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-cardboard-office.json","path":"/projecten/cardboard-office"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-de-muts.json","path":"/projecten/de-muts"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-ravelijn-bridge.json","path":"/projecten/ravelijn-bridge"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-moses-bridge.json","path":"/projecten/moses-bridge"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-schoolgarden.json","path":"/projecten/schoolgarden"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-spaghetti-bridge.json","path":"/projecten/spaghetti-bridge"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-kiosk-at-ravelijn.json","path":"/projecten/kiosk-at-ravelijn"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-bunkertreppe.json","path":"/projecten/bunkertreppe"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-energielinie.json","path":"/projecten/energielinie"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-blauwe-sluis.json","path":"/projecten/blauwe-sluis"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-kansenkaart-steenbergen.json","path":"/projecten/kansenkaart-steenbergen"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-sober.json","path":"/projecten/sober"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-flying-for-biodiversity.json","path":"/projecten/flying-for-biodiversity"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-lettenhofpark.json","path":"/projecten/lettenhofpark"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-limes.json","path":"/projecten/limes"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-evolitiegebouw-nioo-knaw.json","path":"/projecten/evolitiegebouw-nioo-knaw"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-zeeuws-ruimtelijk-decreet.json","path":"/projecten/zeeuws-ruimtelijk-decreet"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-reghthuys-van-wulven.json","path":"/projecten/reghthuys-van-wulven"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-bamboe-doodskist.json","path":"/projecten/bamboe-doodskist"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-good-house.json","path":"/projecten/good-house"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-brabantse-wal.json","path":"/projecten/brabantse-wal"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-koffiehokjes.json","path":"/projecten/koffiehokjes"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-stortemelk-beeldkwaliteitsplan.json","path":"/projecten/stortemelk-beeldkwaliteitsplan"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-praxis.json","path":"/projecten/praxis"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-visie-vesting-den-bosch.json","path":"/projecten/visie-vesting-den-bosch"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-evolvo-et-emergo.json","path":"/projecten/evolvo-et-emergo"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-biobased-brug.json","path":"/projecten/biobased-brug"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-kansenkaart-groot-saefthinge.json","path":"/projecten/kansenkaart-groot-saefthinge"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-hutje-op-de-hei.json","path":"/projecten/hutje-op-de-hei"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-huis-in-de-bosjes.json","path":"/projecten/huis-in-de-bosjes"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-waterpicknicktafels.json","path":"/projecten/waterpicknicktafels"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-olifantenbrug.json","path":"/projecten/olifantenbrug"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-kinderboerderij.json","path":"/projecten/kinderboerderij"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-pompejus.json","path":"/projecten/pompejus"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-kopie.json","path":"/projecten/kopie"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-sportboulevard.json","path":"/projecten/sportboulevard"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-mcjp.json","path":"/projecten/mcjp"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-fort-henricus.json","path":"/projecten/fort-henricus"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-roode-weel.json","path":"/projecten/roode-weel"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-vogeleiland.json","path":"/projecten/vogeleiland"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-uitkerkse-polder.json","path":"/projecten/uitkerkse-polder"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-blauwehandstraat.json","path":"/projecten/blauwehandstraat"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-strandfietsen.json","path":"/projecten/strandfietsen"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-bezoekers-informatie-centrum.json","path":"/projecten/bezoekers-informatie-centrum"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-t-ij.json","path":"/projecten/t-ij"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-entree-peperbus.json","path":"/projecten/entree-peperbus"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-waterschans.json","path":"/projecten/waterschans"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-de-zeemol.json","path":"/projecten/de-zeemol"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-bergse-heide.json","path":"/projecten/bergse-heide"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-zwaluwenbunders.json","path":"/projecten/zwaluwenbunders"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-oud-reimerswaal.json","path":"/projecten/oud-reimerswaal"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-strandpost-dishoek.json","path":"/projecten/strandpost-dishoek"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-natuurkracht.json","path":"/projecten/natuurkracht"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-veldstation-saeftinghe.json","path":"/projecten/veldstation-saeftinghe"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-1-april-monument-brielle.json","path":"/projecten/1-april-monument-brielle"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-uitkijk-radartoren-hedwigepolder.json","path":"/projecten/uitkijk-radartoren-hedwigepolder"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-ontdekkingsreis-naar-nieuw-zeeland.json","path":"/projecten/ontdekkingsreis-naar-nieuw-zeeland"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-uitkijktoren-tureluur.json","path":"/projecten/uitkijktoren-tureluur"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-hub-tholen.json","path":"/projecten/hub-tholen"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-versterk-de-scheldekust.json","path":"/projecten/versterk-de-scheldekust"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-bridges-lilleakerbyen.json","path":"/projecten/bridges-lilleakerbyen"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-energiehuis-deltawind.json","path":"/projecten/energiehuis-deltawind"},{"componentChunkName":"component---src-templates-project-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten-landgoed-ottermeer.json","path":"/projecten/landgoed-ottermeer"},{"componentChunkName":"component---src-pages-404-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-fonts-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"fonts.json","path":"/fonts/"},{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-nieuws-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"nieuws.json","path":"/nieuws/"},{"componentChunkName":"component---src-pages-over-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"over.json","path":"/over/"},{"componentChunkName":"component---src-pages-projecten-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projecten.json","path":"/projecten/"},{"componentChunkName":"component---src-pages-zoek-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"zoek.json","path":"/zoek/"},{"componentChunkName":"component---src-pages-404-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404-html.json","path":"/404.html"}]

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(93);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _gatsbyReactRouterScroll = __webpack_require__(465);
	
	var _domready = __webpack_require__(360);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _history = __webpack_require__(251);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _emitter = __webpack_require__(69);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(549);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(550);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(249);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(248);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(172);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(348);
	}
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    _history2.default.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(254);
	  }
	
	  var navigateTo = function navigateTo(pathname) {
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	
	    // If we're already at this path, do nothing.
	    if (window.location.pathname === pathname) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(pathname);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(pathname);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(pathname);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: _history2.default.location,
	    action: _history2.default.action
	  });
	
	  function attachToHistory(history) {
	    if (!window.___history) {
	      window.___history = history;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: _history2.default })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: _history2.default },
	      children
	    );
	  };
	
	  var ComponentRendererWithRouter = (0, _reactRouterDom.withRouter)(_componentRenderer2.default);
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)(ComponentRendererWithRouter, {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  page: true,
	                  location: { pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	    (0, _domready2.default)(function () {
	      return _reactDom2.default.render(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(69);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(32);
	
	var _reactRedux = __webpack_require__(65);
	
	var _reactGa = __webpack_require__(574);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _state = __webpack_require__(54);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.replaceRouterComponent = function (_ref) {
	  var history = _ref.history;
	
	  var store = (0, _state2.default)();
	  var ConnectedRouterWrapper = function ConnectedRouterWrapper(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(
	        _reactRouterDom.Router,
	        { history: history },
	        children
	      )
	    );
	  };
	  return ConnectedRouterWrapper;
	};
	
	exports.onClientEntry = function () {
	  if (true) {
	    _reactGa2.default.initialize(("UA-111140312-1"), { debug: true });
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search;
	
	    _reactGa2.default.set({ page: "" + pathname + search });
	    _reactGa2.default.pageview("" + pathname + search);
	  }
	};

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(286);
	
	__webpack_require__(287);

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(t,o){(n[t]||(n[t]=[])).push(o)},off:function(t,o){n[t]&&n[t].splice(n[t].indexOf(o)>>>0,1)},emit:function(t,o){(n[t]||[]).map(function(n){n(o)}),(n["*"]||[]).map(function(n){n(t,o)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(3), __webpack_require__(23));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types", "object-assign"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("object-assign")) : factory(root["react"], root["prop-types"], root["object-assign"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OutboundLink = exports.plugin = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	
	var _format2 = __webpack_require__(3);
	
	var _format3 = _interopRequireDefault(_format2);
	
	var _removeLeadingSlash = __webpack_require__(6);
	
	var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _loadGA = __webpack_require__(7);
	
	var _loadGA2 = _interopRequireDefault(_loadGA);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	var _log = __webpack_require__(8);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _OutboundLink = __webpack_require__(9);
	
	var _OutboundLink2 = _interopRequireDefault(_OutboundLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * React Google Analytics Module
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * @package react-ga
	                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
	                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
	                                                                                                                                                                                                     */
	
	/**
	 * Utilities
	 */
	
	
	var _debug = false;
	var _titleCase = true;
	
	var internalGa = function internalGa() {
	  (0, _warn2.default)('ReactGA.initialize must be called first');
	};
	
	function _format(s) {
	  return (0, _format3.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn2.default)('ga command must be a string');
	      return;
	    }
	
	    internalGa.apply(undefined, args);
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn2.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configs, options) {
	  if (typeof window === 'undefined') {
	    return false;
	  }
	
	  (0, _loadGA2.default)();
	  internalGa = function internalGa() {
	    var _window;
	
	    return (_window = window).ga.apply(_window, arguments);
	  };
	
	  if (Array.isArray(configs)) {
	    configs.forEach(function (config) {
	      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
	        (0, _warn2.default)('All configs must be an object');
	        return;
	      }
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configs, options);
	  }
	  return true;
	}
	
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	function ga() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(undefined, args);
	    if (_debug) {
	      (0, _log2.default)('called ga(\'arguments\');');
	      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
	    }
	  }
	
	  return window.ga;
	}
	
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn2.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
	    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn2.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log2.default)('called ga(\'set\', fieldsObject);');
	    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
	  }
	}
	
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	  if (_debug) {
	    (0, _log2.default)('called ga(\'send\', fieldObject);');
	    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
	    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
	  }
	}
	
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function pageview(rawPath, trackerNames) {
	  if (!rawPath) {
	    (0, _warn2.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim2.default)(rawPath);
	  if (path === '') {
	    (0, _warn2.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log2.default)('with path: ' + path);
	    }
	  }
	}
	
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn2.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = '/modal/' + modalName;
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log2.default)('with path: ' + path);
	    }
	  }
	}
	
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments[1];
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var trackerNames = arguments[1];
	
	  var category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn2.default)('args.category AND args.action are required in event()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    };
	
	    // Optional Fields
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn2.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    };
	
	    // Optional Fields
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn2.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    }
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = exports.plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn2.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim2.default)(rawName);
	      if (name === '') {
	        (0, _warn2.default)('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      // Optional Fields
	      if (options) {
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	          (0, _warn2.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn2.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload = void 0;
	    var actionType = void 0;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn2.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = pluginName + ':' + action;
	        payload = payload || null;
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	          }
	        } else if (payload) {
	          ga(command, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
	          }
	        } else {
	          ga(command);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	          }
	        }
	      }
	    }
	  }
	};
	
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn2.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn2.default)('args.label is required in outboundLink()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	
	    var safetyCallbackCalled = false;
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	
	      hitCallback();
	    };
	
	    // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	
	    // register safety net timeout:
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA;
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
	_OutboundLink2.default.trackLink = outboundLink;
	var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
	
	exports.default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = __webpack_require__(4);
	
	var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);
	
	var _toTitleCase = __webpack_require__(5);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail2.default)(s)) {
	    (0, _warn2.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase2.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/.test(s)
	  );
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
	                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
	                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	                                                                                                * https://github.com/gouch/to-title-case
	                                                                                                */
	
	function toTitleCase(string) {
	  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	  /* eslint-disable */
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	  /* eslint-enable */
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(10);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(12);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	
	      var eventMeta = { label: eventLabel };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OutboundLink, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _objectAssign2.default)({}, this.props, {
	        href: this.props.to,
	        onClick: this.handleClick
	      });
	      delete props.eventLabel;
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  to: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null
	};
	
	OutboundLink.trackLink = function () {
	  (0, _warn2.default)('ga tracking not enabled');
	};
	
	exports.default = OutboundLink;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(66);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(85);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(159);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(63);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(160);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(154);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(155);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(156);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(157);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(11);
	
	var _wrapMapToProps = __webpack_require__(64);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(64);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(67);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(158);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(67);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(152);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(63);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(153);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(86);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162898551421021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(265) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(73896326755509, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(266) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(267) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(215951927083960, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(268) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(232751019619440, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(269) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(262252016866534, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(270) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(32977039424393, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(271) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.updateSearchQuery = updateSearchQuery;
	exports.toggleSearchInput = toggleSearchInput;
	exports.setShowSearchInput = setShowSearchInput;
	exports.toggleMobileMenuOpen = toggleMobileMenuOpen;
	
	var _redux = __webpack_require__(11);
	
	var UPDATE_SEARCH_QUERY = "UPDATE_SEARCH_QUERY";
	var TOGGLE_MOBILE_MENU_OPEN = "TOGGLE_MOBILE_MENU_OPEN";
	var TOGGLE_SEARCH_INPUT = "TOGGLE_SEARCH_INPUT";
	var SET_SHOW_SEARCH_INPUT = "SET_SHOW_SEARCH_INPUT";
	
	var initialState = {
	  searchQuery: "",
	  showSearchInput: false,
	  mobileMenu: {
	    open: false,
	    hasBeenOpened: false
	  }
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case UPDATE_SEARCH_QUERY:
	      return _extends({}, state, {
	        searchQuery: action.payload
	      });
	    case TOGGLE_MOBILE_MENU_OPEN:
	      return _extends({}, state, {
	        mobileMenu: {
	          open: !state.mobileMenu.open,
	          hasBeenOpened: true
	        }
	      });
	    case TOGGLE_SEARCH_INPUT:
	      return _extends({}, state, {
	        showSearchInput: !state.showSearchInput
	      });
	    case SET_SHOW_SEARCH_INPUT:
	      return _extends({}, state, {
	        showSearchInput: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	function updateSearchQuery(query) {
	  return {
	    type: UPDATE_SEARCH_QUERY,
	    payload: query
	  };
	}
	
	function toggleSearchInput() {
	  return {
	    type: TOGGLE_SEARCH_INPUT
	  };
	}
	
	function setShowSearchInput(show) {
	  return {
	    type: SET_SHOW_SEARCH_INPUT,
	    payload: show
	  };
	}
	
	function toggleMobileMenuOpen() {
	  return {
	    type: TOGGLE_MOBILE_MENU_OPEN
	  };
	}
	
	var createStore = function createStore() {
	  return (0, _redux.createStore)(reducer, initialState,
	  /* eslint no-underscore-dangle: off  */
	  typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
	    return f;
	  });
	};
	
	exports.default = createStore;

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      2
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(140935043865547, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(272) })
	        }
	      });
	     }
	    

/***/ })

});


// WEBPACK FOOTER //
// app-67ade44cbb75ed34b08a.js